import { TMentionUser } from '@onesource/schemas';

import axios from '../axios';

const cache = new Map<string, TMentionUser>();

export const fetchMentionUsersByIds = async (ids: string[]): Promise<TMentionUser[]> => {
  if (ids.length === 0) {
    return [];
  }

  const uncachedIds = ids.filter(id => !cache.has(id));

  if (uncachedIds.length > 0) {
    const res = await axios.post<TMentionUser[]>('/mention/users/by-ids', {
      ids: uncachedIds,
    });

    res.data.forEach(u => {
      cache.set(u.id, u);
    });
  }

  return ids.map(id => cache.get(id)).filter((u): u is TMentionUser => u !== null && u !== undefined);
};
